<template>
  <div class="day-log-border" style="height: 100%;">
    <v-row class="pb-1">
      <v-col cols="12" class="text-center">
        <b>{{ dayOfTheWeek }}</b>
        <br>
        <b>{{ localDateTime | formatDate }}</b>
      </v-col>
    </v-row>
    <div style="overflow-y: auto; overflow-x: hidden; height: 75%;">
      <div v-if="clockLogs && clockLogs.length > 0">
        <v-row
          v-for="log in clockLogs" :key="log.id">
          <v-col cols="12">
            <SummaryItem :item-title="log.stateDescription">
              <template v-slot:content>
                {{ log.staffLynxLocalDateTime | toTimeOnlyString }}
              </template>
            </SummaryItem>
          </v-col>
        </v-row>
      </div>
      <div v-else>
        <v-row>
          <v-col cols="12" class="text-center">
            No data available
          </v-col>
        </v-row>
      </div>
    </div>
    <v-row v-if="clockLogs && clockLogs.length > 0">
      <v-col cols="12" class="text-center">
        <v-chip
          color="primary"
          class="px-7 py-2"
        >
          {{ parseFloat(workedTime).toFixed(2) }} Hours
        </v-chip>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { SummaryItem } from '@/components/shared/display'

export default {
  components: {
    SummaryItem
  },
  props: [
    'localDateTime',
    'clockLogs',
    'dayOfTheWeek',
    'workedTime'
  ]
}
</script>

<style>
.day-log-border {
  border: 0.1em solid #cccccc;
  border-radius: 7px;
  padding: 15px 10px;
}
</style>
